module.exports = __webpack_public_path__ + "static/img/4.97523a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/sp/4.png
// module id = t5Ip
// module chunks = 0